import script from "./PianoDiagram.vue?vue&type=script&setup=true&lang=js"
export * from "./PianoDiagram.vue?vue&type=script&setup=true&lang=js"

import "./PianoDiagram.vue?vue&type=style&index=0&id=2734eefa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2734eefa"]])

export default __exports__